import { render, staticRenderFns } from "./FormBuilding.vue?vue&type=template&id=15baad63&"
import script from "./FormBuilding.vue?vue&type=script&lang=js&"
export * from "./FormBuilding.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilding.vue?vue&type=style&index=0&id=15baad63&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports